export const types = {
  SET_FILTER_LOADING: "SET_FILTER_LOADING",
  SET_FILTER_SUCCESS: "SET_FILTER_SUCCESS",
  SET_FILTER_FAILED: "SET_FILTER_FAILED",

  SET_FILTER_INITIAL: "SET_FILTER_INITIAL",
  SET_CHILDREN_MENU: "SET_CHILDREN_MENU",
  UPDATE_CHILDREN_MENU_BADGE: "UPDATE_CHILDREN_MENU_BADGE",
};
